angular.module('moebiusProadapt').controller('ctrlParticipantPriseencharge',
    ['$rootScope', '$scope', '$http', 'moment', '$timeout', '$location', '$controller', 'mbsEtiService', 'mbsParticipantService', '$uibModal','eti','questionVisite','participant','questionMere','linkedObject',
        function ($rootScope, $scope, $http, moment, $timeout, $location, $controller, mbsEtiService, mbsParticipantService, $uibModal, eti, questionVisite, participant, questionMere,linkedObject) {

            $scope.priseencharge   = linkedObject;

            console.log('priseencharge received', $scope.priseencharge );

            $scope.title        = questionMere.name;
            $scope.titleConfirm = 'OK';

            if ($scope.priseencharge.editOrSave === 'SAVE') {
                $scope.title        = $scope.title + '-' + 'Ajout';
                $scope.titleConfirm = 'Ajouter';

            } else {
                $scope.title        = $scope.title + '-' + 'Edition';
                $scope.titleConfirm = 'Modifier';
            }

            // -- init
            if ($scope.priseencharge.date_debut) {
                $scope.priseencharge.date_debut = moment($scope.priseencharge.date_debut).hour(12).toDate();
            }

        /**
         * *************************************************************************************************
         * ********************* Initialization
         * *************************************************************************************************
         */
        //
        // /**
        //  * setup the controller
        //  */
        // var initialize = function () {
        // };
        //
        // initialize();
    }]
);



// WEBPACK FOOTER //
// ./resources/assets/js/controllers/etude/participantPriseencharge.js